import { C, T } from '@homeschooling/sdk'

import m from 'moment'
import * as React from 'react'
import * as _ from 'lodash'

import Persistance from "../Persistence";
import { InputField } from './InputField'
import { DatePicker } from '../Common'
import { Exit } from '../../Components/Icons'

import SDKFactory from '../../Components/SDKFactory'
import { Helper } from '../Helpers'

interface Form {
    [key: string]: string
}

export interface Props {
    children?: React.ReactNode
    inPlaceUpdate: (x: T.Expense) => void
    closeForm: () => void
    form: Form
    errors: { [key: string]: string }
    event?: T.Schedule | undefined
    date?: string
    expense: T.Expense
}

export interface State {
    form: Form
    students: T.Student[]
    errors: { [key: string]: string }
    showDatePicker: boolean
}

Persistance.setValues()

export class EditExpenseForm extends React.Component<Props, any> {
    private expenseSdk = SDKFactory.getExpensesSDK()

    public constructor(props: Props) {
        super(props)

        let form = {}


        let expense: T.Expense = this.props.expense

        form = {
            student: expense.students[0].id,
            date: expense.date,
            description: expense.description,
            category: expense.category,
            price: Helper.cleanMoney(expense.price),
            paid_to: expense.paid_to
        }

        //console.log('edit expense form', expense.category,  form)
        this.state = {
            expandExpenses: false,
            expandNotes: false,
            form: form,
            students: Persistance.getStudents(),
            showDatePicker: false
        }
    }

    public editExpense = () => {

        let errors = this.verifyForm()

        if (Object.keys(errors).length !== 0) {
            this.setState({ errors: errors })
            return
        }

        let form = this.state.form

        let data: T.Expense = {
            students: [{
                id: form['student'],
                name: '',
                sex: '',
                dob: '',
                grade: '',
                special_needs: false,
                city: '',
                state: ''
            }],
            schedule_id: form['event_id'],
            category: form['category'],
            price: form['price'],
            description: form['description'],
            date: m(form['date']).format('YYYY-MM-DD'),
            paid_to: form['paid_to']
        }

        this.editExpenseToSdk(data)

    }

    public editExpenseToSdk = async (data: T.Expense) => {
        try {

            let id = this.props.expense.id ? this.props.expense.id?.toString() : '0'
            const res = await this.expenseSdk.patchExpense(id, data)
            let note = res.data

            const hasError: boolean = _.get(note, 'errors', false) as boolean

            if (!hasError && res.status === 'success') {
                note = note as T.Expense

                //console.log('note', note)
                this.props.inPlaceUpdate(note)
                this.setState({ form: {} })
                this.props.closeForm()
            }
            return {}
        } catch (reason) {
            console.log('Error saving schedule event', reason)
            return {}
        }
    }

    public verifyForm = () => {
        const { form } = this.state
        let errors: any = {}

        if (!form.student) errors['student'] = 'Select a student'
        if (!form.category) errors['category'] = 'Select a category'
        if (!form.description) errors['description'] = 'Description is required'
        if (!form.price) errors['price'] = 'Price is required'
        if (!form.paid_to) errors['paid_to'] = 'Paid to is required'
        if (isNaN(form.price) || Number(form.price) < 0) errors['price'] = 'Price must be a positive number'

        if (!m(form.date).isValid()) errors['startDate'] = 'Date is required'

        return errors
    }

    public getStudentOptions = () => {
        let options: any = []

        for (let s of this.state.students) {
            options[s.id] = s.name
        }

        return options
    }

    public getExpenseOption = () => {
        let subjects = C.categories

        let options: any = []

        _.forOwn(subjects, (value, key) => {
            options[key] = value.label
        })

        return options
    }

    public getCourseOption = () => {

        let options: any = []

        if (this.state.form.subject) {
            let courses = C.getSubjectConstants(this.state.form.subject)

            _.forOwn(courses, (value, key) => {
                options[key] = value.label
            })
        }

        return options
    }

    public inputChanged = (key: string) =>
        (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            const { form } = this.state
            form[key] = e.target.value

            this.setState({
                form,
            })
        }

    public setDatePickerFormInfo = (key: string, e: any) => {
        const { form } = this.state
        form[key] = m(e).format()

        this.setState({
            form,
            showDatePicker: false
        })
    }


    public render(): React.ReactNode {

        const { form } = this.state

        return (
            <div className='w-120 flex flex-col'>
                <div className='w-full flex flew-row items-center'>
                    <h2 className='w-auto grow text-left text-l font-semibold text-gray-900'>Edit Expense</h2>
                    <div onClick={() => this.props.closeForm()} className='w-auto flex-none text-right justify-items-end hover:cursor-pointer'>
                        <Exit size='small' />
                    </div>
                </div>

                <form noValidate className="space-y-4 md:space-y-6">
                    <div className='w-full flex flex-col'>
                        <div className='w-full flex flex-row'>
                            <div className='w-1/2 p-2'>
                                <InputField
                                    borderColor='default'
                                    cb={this.inputChanged('student')}
                                    disabled={form.event_id !== undefined}
                                    errors={this.state.errors?.student}
                                    helperErrors={true}
                                    label={'Select A Student'}
                                    labelColor='default'
                                    id='student'
                                    required={true}
                                    options={this.getStudentOptions()}
                                    type='select'
                                    value={form.student}
                                    placeHolder='Choose A Student'
                                />
                            </div>
                        </div>
                        <div className='w-full flex flex-row'>
                            <div className='w-1/2 p-2'>
                                <InputField
                                    borderColor='default'
                                    cb={this.inputChanged('category')}
                                    disabled={false}
                                    errors={this.state.errors?.category}
                                    helperErrors={true}
                                    label={'Category'}
                                    labelColor='default'
                                    id='category'
                                    required={true}
                                    options={this.getExpenseOption()}
                                    type='select'
                                    value={form.category}
                                    placeHolder='Select A Catefory'
                                />
                            </div>
                            <div className='w-1/2 p-2 relative'>
                                <div className='w-full'>
                                    Date*
                                </div>
                                <div className='w-full'>
                                    <DatePicker
                                        date={m(this.state.form.date).format()} cb={(e) => this.setDatePickerFormInfo('date', e)} />
                                </div>

                            </div>
                        </div>
                        <div className='w-full flex flex-row'>
                            <div className='w-1/2 p-2'>
                                <InputField
                                    borderColor='default'
                                    cb={this.inputChanged('price')}
                                    disabled={false}
                                    errors={this.state.errors?.price}
                                    helperErrors={true}
                                    label={'Amount Paid'}
                                    labelColor='default'
                                    id='price'
                                    required={true}
                                    type='money'
                                    value={form.price}
                                    placeHolder='00.00'
                                />
                            </div>
                            <div className='w-1/2 p-2'>
                                <InputField
                                    borderColor='default'
                                    cb={this.inputChanged('paid_to')}
                                    disabled={false}
                                    errors={this.state.errors?.paid_to}
                                    helperErrors={true}
                                    label={'Paid To'}
                                    labelColor='default'
                                    id='location'
                                    required={true}
                                    type='text'
                                    value={form.paid_to}
                                    placeHolder=''
                                />
                            </div>
                        </div>
                        <div className='w-full p-2'>
                            <InputField
                                borderColor='default'
                                cb={this.inputChanged('description')}
                                disabled={false}
                                errors={this.state.errors?.description ? true : false}
                                helperErrors={true}
                                label={'Description'}
                                labelColor='default'
                                id='description'
                                required={false}
                                type='textArea'
                                value={form.description}
                                placeHolder='Expense Description'
                            />
                        </div>
                        <div className='w-full flex flex-row items-center'>
                            <div className='w-auto grow text-right pr-4'>

                            </div>
                            <div className='w-auto flex-none justify-items-right'>
                                <button
                                    onClick={() => this.editExpense()}
                                    type="button"
                                    className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                    Edit
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }

}

export default EditExpenseForm